import { useApi, createApiHook } from "../utils/apiUtils";

const useUnlinkQuestionnaire = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { loading, startLoading } = useApiState();

  const unlinkQuestionnaire = async ({ questionnaireId, parent }) => {
    try {
      startLoading();
      const response = await apiDelete(`questionnaires/${questionnaireId}/unlink`, "Error al desvincular el cuestionario", {
        parent,
      });
      return !response?.error;
    } catch (error) {
      return { data: null, error: error };
    }
  };

  return { unlinkQuestionnaire, loading };
};

export default useUnlinkQuestionnaire;
